import './index.css';
import HelloRemoteReactComp from './App';

export default HelloRemoteReactComp;
